import types from "./types";

// coaching list
export const getAllCoaching = (payload) => ({
  type: types.COACHING_LIST,
  payload,
});
export const getAllCoachingResponse = (payload) => ({
  type: types.COACHING_LIST_RESPONSE,
  payload,
});
export const getAllCoachingClear = () => ({ type: types.COACHING_LIST_CLEAR });

// skills list
export const getAllSkills = (payload) => ({ type: types.CS_GETSKILL, payload });
export const getAllSkillsResponse = (payload) => ({
  type: types.CS_GETSKILL_RESPONSE,
  payload,
});
export const getAllSkillsClear = () => ({ type: types.CS_GETSKILL_CLEAR });

// Action for sending skills and interests
export const coachingRequestSubmit = (payload) => ({
  type: types.COACHING_REQUEST_SUBMIT,
  payload,
});
export const coachingRequestSubmitResponse = (payload) => ({
  type: types.COACHING_REQUEST_SUBMIT_RESPONSE,
  payload,
});
export const coachingRequestSubmitClear = (error) => ({
  type: types.COACHING_REQUEST_SUBMIT_CLEAR,
  error,
});

// skills list
export const getSlots = (payload) => ({ type: types.GET_SLOTS, payload });
export const getSlotsResponse = (payload) => ({
  type: types.GET_SLOTS_RESPONSE,
  payload,
});
export const getSlotsClear = () => ({ type: types.GET_SLOTS_RESPONSE_CLEAR });

export const createSlots = (payload) => ({ type: types.CREATE_SLOTS, payload });
export const createSlotsResponse = (payload) => ({
  type: types.CREATE_SLOTS_RESPONSE,
  payload,
});
export const createSlotsClear = () => ({
  type: types.CREATE_SLOTS_RESPONSE_CLEAR,
});

export const addSlots = (payload) => ({ type: types.ADD_SLOTS, payload });
export const addSlotsResponse = (payload) => ({
  type: types.ADD_SLOTS_RESPONSE,
  payload,
});
export const addSlotsClear = () => ({
  type: types.ADD_SLOTS_RESPONSE_CLEAR,
});

export const deleteSlots = (payload) => ({ type: types.DELETE_SLOTS, payload });
export const deleteSlotsResponse = (payload) => ({
  type: types.DELETE_SLOTS_RESPONSE,
  payload,
});
export const deleteSlotsClear = () => ({
  type: types.DELETE_SLOTS_RESPONSE_CLEAR,
});

export const getSessionNotes = (payload) => ({
  type: types.GET_SESSION_NOTES_LISTING,
  payload,
});
export const getSessionNotesResponse = (payload) => ({
  type: types.GET_SESSION_NOTES_LISTING_RESPONSE,
  payload,
});
export const getSessionNotesClear = () => ({
  type: types.GET_SESSION_NOTES_LISTING_RESPONSE_CLEAR,
});

export const addSessionNotes = (payload) => ({
  type: types.ADD_SESSION_NOTES,
  payload,
});
export const addSessionNotesResponse = (payload) => ({
  type: types.ADD_SESSION_NOTES_RESPONSE,
  payload,
});
export const addSessionNotesClear = () => ({
  type: types.ADD_SESSION_NOTES_RESPONSE_CLEAR,
});

export const registerCoach = (payload) => ({
  type: types.REGISTER_COACH,
  payload,
});
export const registerCoachResponse = (payload) => ({
  type: types.REGISTER_COACH_RESPONSE,
  payload,
});
export const registerCoachResponseClear = () => ({
  type: types.REGISTER_COACH_RESPONSE_CLEAR,
});

export const getCoachingListing = (payload) => ({
  type: types.COACHING_LISTING,
  payload,
});
export const getCoachingListingRes = (payload) => ({
  type: types.COACHING_LISTING_RESPONSE,
  payload,
});
export const getCoachingListingClear = (payload) => ({
  type: types.COACHING_LISTING_CLEAR,
  payload,
});

export const CoachRatingg = (payload) => ({
  type: types.COACH_RATING,
  payload,
});
export const CoachRatingRes = (payload) => ({
  type: types.COACH_RATING_RESPONSE,
  payload,
});
export const CoachRatingClear = (payload) => ({
  type: types.COACH_RATING_RESPONSE_CLEAR,
  payload,
});

export const getCoachingPersonalListing = (payload) => ({
  type: types.COACHING_PERSONAL_LISTING,
  payload,
});
export const getCoachingPersonalListingRes = (payload) => ({
  type: types.COACHING_PERSONAL_LISTING_RESPONSE,
  payload,
});
export const getCoachingPersonalListingClear = (payload) => ({
  type: types.COACHING_PERSONAL_LISTING_CLEAR,
  payload,
});

export const GetCoachRating = (payload) => ({
  type: types.GET_COACH_RATING,
  payload,
});
export const GetCoachRatingRes = (payload) => ({
  type: types.GET_COACH_RATING_RESPONSE,
  payload,
});
export const GetCoachRatingClear = (payload) => ({
  type: types.GET_COACH_RATING_RESPONSE_CLEAR,
  payload,
});

export const GetMasterIndustryData = (payload) => ({
  type: types.GET_MASTER_INDUSTRY_DATA,
  payload,
});
export const GetMasterIndustryDataRes = (payload) => ({
  type: types.GET_MASTER_INDUSTRY_DATA_RESPONSE,
  payload,
});
export const GetMasterIndustryDataResClear = (payload) => ({
  type: types.GET_MASTER_INDUSTRY_DATA_RESPONSE_CLEAR,
  payload,
});

export const GetCoachingServices = (payload) => ({
  type: types.GET_COACHING_SERVICES,
  payload,
});
export const GetCoachingServicesRes = (payload) => ({
  type: types.GET_COACHING_SERVICES_RESPONSE,
  payload,
});
export const GetCoachingServicesResClear = (payload) => ({
  type: types.GET_COACHING_SERVICES_RESPONSE_CLEAR,
  payload,
});

export const GetCoachingServiceDetail = (payload) => ({
  type: types.GET_COACHING_SERVICE_DETAIL,
  payload,
});
export const GetCoachingServiceDetailRes = (payload) => ({
  type: types.GET_COACHING_SERVICE_DETAIL_RESPONSE,
  payload,
});
export const GetCoachingServiceDetailResClear = (payload) => ({
  type: types.GET_COACHING_SERVICE_DETAIL_RESPONSE_CLEAR,
  payload,
});

export const getCoachingRequestSend = (payload) => ({
  type: types.COACHING_REQUEST_SEND,
  payload,
});
export const getCoachingRequestSendResponse = (payload) => ({
  type: types.COACHING_REQUEST_SEND_RESPONSE,
  payload,
});
export const getCoachingRequestSendClear = () => ({
  type: types.COACHING_REQUEST_SEND_RESPONSE_CLEAR,
});

export const getCoachingRequestsList = (payload) => ({
  type: types.COACHING_REQUESTS_LIST,
  payload,
});
export const getCoachingRequestsListResponse = (payload) => ({
  type: types.COACHING_REQUESTS_LIST_RESPONSE,
  payload,
});
export const getCoachingRequestsListClear = () => ({
  type: types.COACHING_REQUESTS_LIST_RESPONSE_CLEAR,
});

export const rescheduleSlots = (payload) => ({
  type: types.RESCHEDULE_SLOTS,
  payload,
});
export const rescheduleSlotsResponse = (payload) => ({
  type: types.RESCHEDULE_SLOTS_RESPONSE,
  payload,
});
export const rescheduleSlotsClear = () => ({
  type: types.RESCHEDULE_SLOTS_RESPONSE_CLEAR,
});

export const getCoachingRequestUpdate = (payload) => ({
  type: types.COACHING_REQUESTS_UPDATE,
  payload,
});
export const getCoachingRequestUpdateResponse = (payload) => ({
  type: types.COACHING_REQUESTS_UPDATE_RESPONSE,
  payload,
});
export const getCoachingRequestUpdateClear = () => ({
  type: types.COACHING_REQUESTS_UPDATE_RESPONSE_CLEAR,
});
export const getMyBookingRequest = (payload) => ({
  type: types.GET_MY_BOOKING_LIST,
  payload,
});
export const getMyBookingRequestResponse = (payload) => ({
  type: types.GET_MY_BOOKING_LIST_RESPONSE,
  payload,
});
export const getMyBookingRequestClear = () => ({
  type: types.GET_MY_BOOKING_LIST_RESPONSE_CLEAR,
});

export const getAICoachingUrl = (payload) => ({
  type: types.AI_COACHING_URL,
  payload,
});
export const getAICoachingUrlResponse = (payload) => ({
  type: types.AI_COACHING_URL_RESPONSE,
  payload,
});
export const getAICoachingUrlClear = () => ({
  type: types.AI_COACHING_URL_RESPONSE_CLEAR,
});
